// extracted by mini-css-extract-plugin
export default {"block-title":"Text_block-title__EPlN0","break-text":"Text_break-text__pqh-B","char-text":"Text_char-text__w71AH","quote":"Text_quote__wOnga"};